import { render } from "./AskBotModal.vue?vue&type=template&id=2f4b4e0e&scoped=true"
import script from "./AskBotModal.vue?vue&type=script&lang=js"
export * from "./AskBotModal.vue?vue&type=script&lang=js"

import "./AskBotModal.vue?vue&type=style&index=0&id=2f4b4e0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4b4e0e"]])

export default __exports__